export default {
    props: [
        "isCapitalize",
        "stepNumber",
        "subtitle",
        "title",
        "isPrimaryTitleColor",
        "titleWeight",
    ],
    template: `
  	    <div v-if="title" class="form-section-header-container" :class="{ 
            'form-section-header-capitalize': isCapitalize, 
            'form-section-header-primary-title': isPrimaryTitleColor,
            'form-section-header-normal': titleWeight === 'normal',
            'form-section-header-container': titleWeight === 'bold' || !titleWeight, 
        }"><span v-if="stepNumber || stepNumber === 0">{{ stepNumber + 1 }}.</span> {{ title }}</div>
        <div v-if="subtitle" class="form-section-header-normal">{{ subtitle }}</div>
	`,
};